<template lang="pug">
.shortage
  .shortSearch
      el-select(size="mini" class="sn_type" v-model="shortType")
          el-option(v-for="(item, i) in ['梯内屏', '梯外屏']" :key="i" :value="i" :label="item")
      el-input.search(v-model="nbhdShortSearchStr" @keyup.enter="searchNbhd" @input="searchChange" placeholder="查找小区" size="small" clearable)
          el-button(slot="append" icon="el-icon-search" @click="clickSearch")
  .no_nbhd(v-if="!list || list.filter(el => !el.notShow).length === 0") 暂无结果，换个名称重新试试吧～
  .shortArea(v-for="(item, i) in list" :key="item.name + '_' + i" v-if="!item.notShow")
      .shortLine
          .lineTitle(@click="item.areaBoxOpen = !item.areaBoxOpen")
              span.short_title {{item.name}}
              .fr
                  span 缺货：
                  span.data.frTitle(style="color:#FF3973") {{item.shortageAmount}}次
                  span 总屏幕数：
                  span.data.frTitle.no-br {{item.deviceCount}}个
                  i.el-icon-arrow-down(:class="{'isOppen':item.areaBoxOpen}")
          .clear
          .shortDetail(v-show="item.areaBoxOpen" v-for="(dayShortList, index) in item.daysNbhdSlotShortageResList" :key="dayShortList.targetDate + '_' + index")
              .shortDetailTitle(@click="lesBoxCli(dayShortList)")
                  span.tot {{dayShortList.targetDate}}
                  .fr
                      span 缺货小计：
                      span.data.frTitle.no-br(style="color:#FF3973;margin-right:10px;") {{dayShortList.shortageAmount}}次
                      i.el-icon-arrow-down(:class="{'isOpeen':dayShortList.lessBoxOpen}")
              .lessBox(v-show="dayShortList.lessBoxOpen" v-for="(shortDetail, j) in dayShortList.buildDeviceList" :key="shortDetail.build + '_' + j")
                  .shortDetailDe(v-for="(unitAndLift, k) in shortDetail.value" :key="k")
                      span.tlt {{shortDetail.build}}{{unitAndLift.unit}}
                      .fr
                          span {{unitAndLift.elevatorNos.toString()}}
                          b (缺货)
</template>

<script>
export default {
    name: 'ShortNbhdList',
    props: ['data'],
    data () {
        return {
            areaOpen: false,
            nbhdShortSearchStr: '',
            list: [],
            shortByDevGuids: [],
            shortType: 0
        }
    },
    created () {
        // this.list = this.data[this.shortType].map(el => {
        //     this.$set(el, 'areaBoxOpen', false)
        //     this.$set(el, 'notShow', false)
        //     return el
        // })
    },
    watch: {
        shortType: {
            immediate: true,
            handler (v) {
                this.list = []
                this.$nextTick(() => {
                    // this.data中第一项是梯内数据列表 第二项是梯外数据列表
                    this.list = this.data[this.shortType].map(el => {
                        this.$set(el, 'areaBoxOpen', false)
                        this.$set(el, 'notShow', false)
                        return el
                    })
                    this.$nextTick(() => {
                        this.searchNbhd()
                    })
                })
            }
        }
    },
    methods: {
        async lesBoxCli (val) {
            let guids = val.deviceGuids.toString()
            if (val.lessBoxOpen === undefined) this.$set(val, 'lessBoxOpen', false)
            val.lessBoxOpen = !val.lessBoxOpen
            if (val.buildDeviceList && val.buildDeviceList.length > 0) return
            let res = await this.fetch('/boss/deviceSlot/v2/getNbhdShortageAllDevice?deviceGuids=' + guids)
            if (res.code === 0) {
                val.buildDeviceList = res.data
            }
        },
        searchChange(val) { // 筛选小区
            val = val.replace(/\s*/g, '')
            this.nbhdShortSearchStr = val
            this.searchNbhd()
        },
        clickSearch() {
            if (!this.nbhdShortSearchStr) return
            this.searchNbhd()
        },
        searchNbhd () {
            if (!this.nbhdShortSearchStr) {
                this.list.forEach(el => {
                    this.$set(el, 'notShow', false)
                })
            } else {
                this.list.forEach(el => {
                    if (el.name.indexOf(this.nbhdShortSearchStr) < 0) { // 不符合搜索条件，隐藏
                        this.$set(el, 'notShow', true)
                    } else {
                        this.$set(el, 'areaBoxOpen', true) // 搜索结果小区默认展开
                        this.$set(el, 'notShow', false)
                    }
                })
            }
        }
    }
}
</script>


<style lang="sass">
.el-select-dropdown__item
    &.selected
        color: #FF3973
</style>
<style lang="sass" scoped>
.no_nbhd
    background: #fff
    border-radius: 4px
    color: #999
    font-size: 14px
    margin-top: 10px
    width: 100%
    height: 62px
    line-height: 62px
    text-align: center
.shortage
    .shortSearch
        width: 240px
        margin: 0 auto
        position: relative
        .search
            width: 100%
            height: 30px
            ::v-deep .el-input-group__append
                background: transparent
                border: none
                width: 30px
                padding: 0
                position: absolute
                right: 0
                top: 0
                bottom: 0
                .el-button
                    width: 100%
                    height: 100%
                    margin: 0
                    padding: 0

        ::v-deep .el-input__inner
            height: 30px
            border-radius: 15px
        ::v-deep .el-input__icon
            line-height: 30px
        ::v-deep .el-select
            position: absolute
            top: 0
            left: -255px
            width: 120px
            .el-input__suffix
                right: 10px
        .sn_type
            ::v-deep .el-input__inner
                border-color: #e9e9e9
                &:focus
                    border-color: #e9e9e9
    .shortArea
        background-color: #fff
        padding: 20px
        margin-top: 10px
        .shortLine
            .lineTitle
                margin-bottom: 10px
                .short_title
                    font-size: 16px
                    color: #282729
                .fr
                    .frTitle
                        padding-right: 20px
                        margin-right: 20px
                        border-right: 1px solid #e9e9e9
                    span
                        display: inline-block
                        font-weight: 400
                        color: #999999
                        &.data
                            color: #282729
                            font-weight: 600
                    i
                        cursor: pointer
                    i.isOppen
                        transform: rotate(180deg)
            .shortDetail
                background-color: #F5F5F5
                padding: 10px
                margin: 10px 0
                .shortDetailTitle
                    cursor: pointer
                    height: 40px
                    font-size: 12px
                    padding: 10px 0
                    .tot
                        font-size: 14px
                        font-weight: 400
                        color: #282729
                        line-height: 20px
                    i
                        cursor: pointer
                    i.isOpeen
                        transform: rotate(180deg)
                .shortDetailDe
                    height: 30px
                    padding: 5px 0
                    border-top: 1px solid #E9E9E9
                    .tlt
                        font-size: 12px
                .lessBox:last-child
                    border-bottom: 1px solid #E9E9E9
</style>
